<template>
  <div ref="aliyunPlayer" :id="playerId" class="aliyun-player"></div>
</template>

<script>
import Aliplayer from 'aliyun-aliplayer';
import 'aliyun-aliplayer/build/skins/default/aliplayer-min.css';

export default {
  name: 'AliyunPlayer',
  props: {
    url: { // 播放地址 直播流/视频文件地址
      type: String,
      required: true,
    },
    autoplay: { // 自动播放
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '500px',
    },
  },
  data() {
    return {
      player: null,
      playerId: 'aliyun-player-' + Math.random().toString(36).substr(2, 9), // 生成唯一的ID
    };
  },
  mounted() {
    this.initPlayer();
  },
  methods: {
    initPlayer() {
      if (!this.url) return;

      this.player = new Aliplayer(
        {
          id: this.playerId, // 使用字符串 ID
          source: this.url, // 播放地址 直播流/视频文件地址
          isLive: true, // 是否为直播播放
          width: this.width,
          height: this.height,
          autoplay: this.autoplay, // 自动播放
          controlBarVisibility: 'hover', // 播放控制条显示模式 always: 总是显示 hover: 鼠标移入显示
          rePlay: false, // 播放器自动循环播放
          useH5Prism: true, // H5 播放
          playsinline: true, // H5 播放内嵌模式
          preload: true, // 预加载
          // skinLayout: false, // 隐藏所有功能组件
        },
        (player) => {
          console.log('播放器已创建');
          player.on('play', () => {
            console.log('视频播放开始');
          });
          player.on('ended', () => {
            console.log('视频播放结束');
          });
        }
      );
    },
  },
  watch: {
    url(newUrl) {
      if (this.player) {
        this.player.loadByUrl(newUrl);
      } else {
        this.initPlayer();
      }
    },
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>

<style scoped>
.aliyun-player {
  position: relative;
}
</style>
